import * as React from 'react';
import classNames from 'classnames';
import { IProps } from "../../common";

type Props = React.PropsWithChildren<{divider?: boolean; full?: boolean} & IProps>;

const ClassName = `form-block card-block`;

export class FormBlock extends React.PureComponent<Props> {
    render() {
        const {className, divider, full, children, ...other} = this.props;

        const clsNames = classNames(ClassName, className, {
            divider: divider,
            full: full,
        });

        const bodyContent = (
            <div {...other} className={clsNames}>
                {children}
            </div>
        );

        return bodyContent;
    }
}
